import React, { PropsWithChildren } from "react";
import { BlackScreen, IconContainer, ModalContainer } from "./style";
import { Button } from "nectar-ui";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";
import OutsideClickHandler from "react-outside-click-handler";

type ModalProps = {
  isOpen: boolean;
  blackout?: boolean;
  onClose: () => void;
  noButton?: boolean;
};

const Modal: React.FC<ModalProps & PropsWithChildren> = ({
  isOpen,
  blackout = false,
  children,
  noButton = false,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
  };

  return (
    <BlackScreen isOn={blackout}>
      <OutsideClickHandler onOutsideClick={handleClose}>
        <IconContainer onClick={handleClose} id="close-modal-icon">
          <FaTimes size={20} />
        </IconContainer>
        <ModalContainer>
          {children}

          {!noButton && (
            <Button color="primary" block onClick={handleClose} id="close-modal-button">
              Fechar
            </Button>
          )}
        </ModalContainer>
      </OutsideClickHandler>
    </BlackScreen>
  );
};

export default Modal;
